import { AuthBroadcastMessage } from '../constants/broadcast/auth'
import { BroadcastChannels } from '../constants/broadcast/channels'
import { DesktopBroadcastMessage } from '../constants/broadcast/desktop'
import { NotificationsBroadcastMessage } from '../constants/broadcast/notifications'

export type BroadcastMessageMap = {
  [BroadcastChannels.DESKTOP]: DesktopBroadcastMessage
  [BroadcastChannels.AUTH]: AuthBroadcastMessage
  [BroadcastChannels.NOTIFICATIONS]: NotificationsBroadcastMessage
}

export type Unsubscribe = () => void

export function createTypedBroadcastChannel<C extends BroadcastChannels>(
  name: C
) {
  const channel = new BroadcastChannel(name)

  const post = (message: BroadcastMessageMap[C]) => channel.postMessage(message)

  const subscribe = (
    handler: (message: BroadcastMessageMap[C]) => void
  ): Unsubscribe => {
    const listener = (event: MessageEvent) => {
      handler(event.data as BroadcastMessageMap[C])
    }
    channel.addEventListener('message', listener)
    return () => channel.removeEventListener('message', listener)
  }

  const close = () => channel.close()

  return { name, channel, post, subscribe, close }
}

export function postMessage<C extends BroadcastChannels>(
  name: C,
  message: BroadcastMessageMap[C]
) {
  const channel = new BroadcastChannel(name)
  channel.postMessage(message)
  channel.close()
}
